var map = {
	"./de-DE/btn_result-text.png": "15c9",
	"./en-GB/btn_result-text.png": "ca01",
	"./en-US/btn_result-text.png": "07ac",
	"./es-ES/btn_result-text.png": "fec6",
	"./es-MX/btn_result-text.png": "19d5",
	"./fr-CA/btn_result-text.png": "186d",
	"./fr-FR/btn_result-text.png": "13f6",
	"./it-IT/btn_result-text.png": "57fd",
	"./ja-JP/btn_result-text.png": "f196",
	"./pt-BR/btn_result-text.png": "1dd0",
	"./zh-TW/btn_result-text.png": "0fed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3e";